export const SEARCH_HOTKEY = 's s'